export default {
    default: {
        colors_demo: false, // OBS! ALL PAGES WILL GO TO COLOR DEMO! TURN OFF FOR ROUTER TO WORK!
        languages: [{ name: "Svenska", eng_name: "Swedish", code: "sv" }],
        translations: ["carlbergspel", "default"],
        public_pages:[ '/loggain', '/glomt-losenord', '/skapa-konto'],
        keep_websocketid: false
    },    
    account: {
        force_ssnr: true,
        show_stored_users: true,
        login_in_modal: true,
        logout_confirm: true,
        auth_url: "account/login",
        register_url: "account/create-account",
        forgot_password_url: "account/forgot-password",
        auth_cancel_url: "auth/cancel",
        user_url: "user",
        select_access_url: "user/selectaccess"
    },
    menu: {
        position: "top",
        display_user: true,
        display_user_access: false,
        display_language: true,
        display_logout: true,
        single_group_open: true        
    },
    company: {

    }
}